import React from "react";

const CustomerUnit = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h5 className="title_text text-dark">Our Commitment</h5>
            <p className="text-dark opacity-50">
              At Topcoin UK, we are committed to protecting the value and
              security of every customer’s TopCoin and cash rewards earned through
              purchases at participating businesses. We provide a three-layer
              protection system to ensure that both TopCoin and cash balances are
              safeguarded within the Topcoin UK ecosystem.
            </p>
            <h5 className="title_text text-dark">
              1. Company-Backed Guarantee (Internal Assurance)
            </h5>
            <p className="text-dark opacity-50">Topcoin UK guarantees that:</p>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - All TopCoin and cash balances are securely stored within the
                Topcoin UK network.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - TopCoin and cash cannot be lost, removed, or manipulated without
                user action or valid cause.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Every TopCoin and cash movement is traceable via our internal
                ledger and blockchain system.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - In case of accidental system errors, we will restore affected
                balances based on internal records.
              </li>
            </ul>
          </div>
          <div className="col-lg-12">
            <h5 className="title_text text-dark">
              2. Topcoin UK Reserve Wallet ,Our Self-Insurance Fund
            </h5>
            <p className="text-dark opacity-50">
              {" "}
              Topcoin UK maintains a dedicated Reserve Wallet to ensure customer
              protection. This reserve is designed to:
            </p>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Cover technical malfunctions or fraud that may affect customer
                TopCoin or cash balances.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Allow compensation or restoration of lost TopCoin or cash.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Provide a safety net when issues are caused by internal
                failure.
              </li>
            </ul>
          </div>
          <div className="col-lg-12">
            <h5 className="title_text text-dark">
              3. Operational Insurance (Business Continuity Protection)
            </h5>
            <p className="text-dark opacity-50">
              {" "}
              Topcoin UK also maintains insurance policies that protect our
              systems and data. This includes:
            </p>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Cloud infrastructure and server protection.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Data backup and cybersecurity insurance.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Internal fraud and operational continuity protection.
              </li>
            </ul>
            <h5 className="text-dark">Immediate Access to Cash</h5>
              <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Customers can convert and cash out their TopCoin at any time without needing to reach milestones.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Milestones are designed to increase rewards and bonuses but are not required to access cash value.
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - This ensures full flexibility for customers while maintaining the loyalty based growth system.

              </li>
                <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - In case of accidental system errors, we will restore affected balances based on internal records.

              </li>

            </ul>
             <h5 className="text-dark">Legal Classification</h5>
          
              <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - Topcoin UK are loyalty rewards that can be converted into cash within the Topcoin UK ecosystem.

              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - TopCoin are not traded, sold, or exchanged like cryptocurrency.

              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >
                - All cash rewards are funded by Topcoin UK’s advertising system and participating businesses, not customer deposits or investments.
              </li>
                <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="list-unstyled text-dark opacity-75"
              >This policy does not constitute financial insurance under UK law and does not require FCA approval.</li>
            </ul>
          </div>
      
        </div>
      </div>
    </section>
  );
};

export default CustomerUnit;
